import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useAgentData } from 'pages/NIC/components/Agents/hooks/useAgentData';
import { BaseDirectoryList } from './BaseDirectoryList';
import { useAgentListRenderers } from './hooks/useAgentListRenderers';
export var AgentList = function (_a) {
    var agents = _a.agents, setAgentToCall = _a.setAgentToCall;
    var _b = useAgentListRenderers(setAgentToCall, agents), renderAgentDescription = _b.renderAgentDescription, renderAgentActions = _b.renderAgentActions, renderFooter = _b.renderFooter;
    var _c = useAgentData(), getAgentFullName = _c.getAgentFullName, isAgentAvailable = _c.isAgentAvailable, getAgentId = _c.getAgentId, getAgentState = _c.getAgentState;
    var agentItems = useMemo(function () {
        return agents.map(function (agent) { return ({
            id: getAgentId(agent),
            name: getAgentFullName(agent),
            status: getAgentState(agent),
            description: agent.outStateDescription || '',
            isFavorite: agent.isFavorite,
            isAvailable: isAgentAvailable(agent),
            additionalInfo: { raw: agent }
        }); });
    }, [agents, isAgentAvailable, getAgentFullName, getAgentId, getAgentState]);
    return (_jsx(BaseDirectoryList, { items: agentItems, renderDescription: renderAgentDescription, renderActions: renderAgentActions, renderFooter: renderFooter, emptyText: "Agents not found" }));
};
